var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightTrackerRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 62,
    viewBox: "0 0 79 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9418_4606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6869 61C63.4447 61 64.921 59.5651 65.1236 57.6663L70.0944 10.9232C70.3312 8.68646 68.726 6.72463 66.6577 6.72463L49.8007 6.70459C46.8087 2.69214 41.3274 0 35.0593 0C28.7912 0 23.3072 2.69214 20.3179 6.70459L3.46086 6.72463C1.39255 6.72463 -0.212636 8.68646 0.024194 10.9232L4.995 57.6663C5.19762 59.5651 6.67649 61 8.43167 61H61.6869Z",
    fill: "#D8E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5607 21.6059L51.9001 16.4307C53.4342 13.0369 56.6104 10.8889 60.0865 10.8975C62.8943 10.9004 65.0731 13.5639 64.7494 16.5997L61.9654 42.7708C61.2154 49.8133 55.7367 55.1289 49.2213 55.1289H20.8858C14.3704 55.1289 8.8917 49.8133 8.14173 42.7708L5.36029 16.5997C5.03662 13.5639 7.21546 10.9004 10.0232 10.8975C13.4994 10.8889 16.6755 13.0369 18.2097 16.4307L20.549 21.6059C21.7516 24.2694 24.2436 25.9563 26.9697 25.9563H43.1374C45.8635 25.9563 48.3529 24.2694 49.5581 21.6059",
    fill: "#697079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1953 19.7531L47.5926 14.2457L46.2085 12.3869C43.9823 9.39981 39.7088 7.54395 35.0538 7.54395C30.3988 7.54395 26.1253 9.39981 23.9017 12.3869L22.5176 14.2457L23.9175 19.7531H46.1953Z",
    fill: "#F4F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0584 9.76367C34.8242 9.76367 34.6348 9.96988 34.6348 10.2248V12.2639C34.6348 12.5188 34.8242 12.725 35.0584 12.725C35.2926 12.725 35.4821 12.5188 35.4821 12.2639V10.2248C35.4821 9.96988 35.2926 9.76367 35.0584 9.76367Z",
    fill: "#1A586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9537 17.0432L25.338 16.0065C25.2406 15.9434 25.1275 15.9263 25.017 15.9578C24.9064 15.9893 24.8143 16.0637 24.7591 16.1697C24.7012 16.2757 24.6854 16.3988 24.7143 16.5191C24.7433 16.6394 24.8117 16.7368 24.9091 16.7998L26.5248 17.8365C26.5906 17.8795 26.6642 17.8996 26.7379 17.8996C26.8879 17.8996 27.0274 17.8136 27.1037 17.6733C27.1616 17.5673 27.1774 17.4442 27.1484 17.3239C27.1195 17.2036 27.0511 17.1062 26.9537 17.0432Z",
    fill: "#1A586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1212 11.5623C40.9212 11.4335 40.6607 11.5079 40.5423 11.7256L39.5924 13.4841C39.4739 13.7017 39.5424 13.9853 39.7424 14.1142C39.8081 14.1571 39.8818 14.1772 39.9581 14.1772C40.1081 14.1772 40.2476 14.0912 40.3213 13.9509L41.2739 12.1924C41.3923 11.9748 41.3239 11.6912 41.1239 11.5623",
    fill: "#1A586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7199 11.6425C29.6041 11.422 29.3462 11.3446 29.1436 11.4707C29.0463 11.5308 28.9752 11.631 28.9436 11.7485C28.9147 11.8659 28.9278 11.9919 28.9831 12.0979L29.912 13.8707C29.9883 14.0139 30.1278 14.1027 30.2804 14.1027C30.3541 14.1027 30.4251 14.0826 30.4909 14.0425C30.5883 13.9824 30.6593 13.8821 30.6883 13.7647C30.7172 13.6473 30.7041 13.5213 30.6488 13.4153L29.7225 11.6425H29.7199Z",
    fill: "#1A586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4421 16.3329C45.3263 16.1124 45.0684 16.0351 44.8658 16.1611L43.2369 17.1721C43.0343 17.2981 42.9632 17.5788 43.079 17.7993C43.1553 17.9425 43.2948 18.0313 43.4474 18.0313C43.5211 18.0313 43.5922 18.0112 43.6579 17.9711L45.2868 16.9601C45.4894 16.8341 45.5605 16.5534 45.4447 16.3329",
    fill: "#1A586B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8664 16.3535C34.7454 16.3535 34.6269 16.3592 34.5059 16.3678L33.6165 12.7563C33.5533 12.4985 33.3165 12.341 33.077 12.3926C32.8376 12.447 32.677 12.6961 32.7139 12.9596L33.2165 16.6112C31.6902 17.101 30.4245 18.2465 29.6982 19.753H40.0346C39.0583 17.731 37.111 16.3535 34.8664 16.3535Z",
    fill: "#F6915A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.7988,
    cy: 48.5,
    r: 12.5,
    fill: "#73BE5E",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2988 47.6602L63.3638 51.6625L69.484 45",
    stroke: "white",
    strokeWidth: 2.30472,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9418_4606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.1149,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightTrackerRequested);
export default __webpack_public_path__ + "static/media/WeightTrackerRequested.b410b943093c3116ae1cfcf44a175c89.svg";
export { ForwardRef as ReactComponent };